"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GasSection = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var components_1 = require("../../../../../../../shared/core/components");
var copy_1 = require("../../../../../copy");
var ChargesTable_1 = require("../ChargesTable");
var MeterReadingsTable_1 = require("../MeterReadingsTable");
var GasSection = function (_a) {
    var consumption = _a.consumption, standing = _a.standing, rest = __rest(_a, ["consumption", "standing"]);
    var _b = (0, core_1.useComponents)(), Row = _b.Row, Col = _b.Col;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var charges = [
        {
            friendlyLabel: 'Anytime',
            consumptionRates: consumption.rates,
            isMultiRate: false,
        },
    ];
    return (react_1.default.createElement(components_1.NestedSection, __assign({ "data-testid": "gas-section", icon: "gas", heading: react_1.default.createElement(Copy, { copyKey: "gasSectionTitle" }) }, rest),
        react_1.default.createElement(Row, { isNested: true },
            react_1.default.createElement(Col, { large: 6 },
                react_1.default.createElement(MeterReadingsTable_1.MeterReadingsTable, { supplyPointRegisterCharges: charges, fuel: "gas" })),
            react_1.default.createElement(Col, { large: 6 },
                react_1.default.createElement(ChargesTable_1.ChargesTable, { standing: standing, supplyPointRegisterCharges: charges })))));
};
exports.GasSection = GasSection;
